import { render, staticRenderFns } from "./ErrorOverlay.vue?vue&type=template&id=088d3bca&scoped=true&"
import script from "./ErrorOverlay.vue?vue&type=script&lang=js&"
export * from "./ErrorOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ErrorOverlay.vue?vue&type=style&index=0&id=088d3bca&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088d3bca",
  null
  
)

export default component.exports